'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TileContextProvider = exports.TileContextConsumer = exports.defaultTileContext = undefined;

var _react = require('react');

var defaultTileContext = exports.defaultTileContext = { compact: false };

var _createContext = (0, _react.createContext)(defaultTileContext),
    Consumer = _createContext.Consumer,
    Provider = _createContext.Provider;

exports.TileContextConsumer = Consumer;
exports.TileContextProvider = Provider;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/context/TileContext.js
// module id = 644
// module chunks = 3 4